import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/MainContainer.css';
import YearView from '../statistics/YearView';
import EventView from '../statistics/EventView';
import './Statistics.css';
import { isAdmin } from '../../util/auth';
import OfflineBanner from '../shell/OfflineBanner';

function Statistics() {
  const [searchParams, setSearchParams] = useSearchParams();
  const preselectedEventId = searchParams.get('eventId');
  const initialTab = preselectedEventId || !isAdmin() ? 'event' : 'year';
  const [tab, setTab] = useState(initialTab);

  const switchTab = (next) => {
    setTab(next);
    if (next === 'year' && searchParams.has('eventId')) {
      searchParams.delete('eventId');
      setSearchParams(searchParams, { replace: true });
    }
  };

  return (
    <React.Fragment>
      <main className="defaultExtendedMain statisticsMain">
        <OfflineBanner />
        <div className="statsTabs">
          {isAdmin() && (
            <button
              type="button"
              className={`statsTab ${tab === 'year' ? 'active' : ''}`}
              onClick={() => switchTab('year')}
            >
              Jahr
            </button>
          )}
          <button
            type="button"
            className={`statsTab ${tab === 'event' ? 'active' : ''}`}
            onClick={() => switchTab('event')}
          >
            Spieltag
          </button>
        </div>

        {tab === 'year'
          ? <YearView />
          : <EventView preselectedEventId={preselectedEventId ? Number(preselectedEventId) : null} />
        }
      </main>
    </React.Fragment>
  );
}

export default Statistics;
